// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_a3-4";
export var collapsed = "_a3-1";
export var headerBar = "_a3-0";
export var leftHeaderContent = "_a3-3";
export var subjectContainer = "_a3-2";